import { render, staticRenderFns } from "./SettingDoctorSayInfo.vue?vue&type=template&id=52a3c215&scoped=true&"
import script from "./SettingDoctorSayInfo.vue?vue&type=script&lang=js&"
export * from "./SettingDoctorSayInfo.vue?vue&type=script&lang=js&"
import style0 from "./SettingDoctorSayInfo.vue?vue&type=style&index=0&id=52a3c215&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a3c215",
  null
  
)

export default component.exports